// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section "Affectation des membres sur les lots" en vue carte. Palette fermee du design system. */
.affectation-carte {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.affectation-carte-info {
  color: #6b7280;
  font-size: 1.3rem;
  padding: 1rem 0;
}

/* ── Barre d'outils : dropdowns lot/departement a gauche, toggle Carte/Liste serre a droite.
   Gap entre filtres = gap du board (panneau <-> carte), pour l'alignement visuel. ── */
.affectation-carte-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 2.5rem;
}
.affectation-carte-toolbar .view-switch {
  margin-left: auto;
  align-self: flex-end;
}
/* Consigne : Banner info en tete de section (la marge est geree par le gap du conteneur). */
.affectation-carte-consigne-banner {
  margin: 0;
}
.affectation-carte-erreur {
  padding: 0.9rem 1.2rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 0.6rem;
  color: #b91c1c;
  font-size: 1.25rem;
  font-weight: 600;
}

/* Bascule Carte / Liste : composant partage ViewSwitch (style repris du selecteur de perimetre). */
/* Largeur calee sur le panneau de gauche (30rem) -> le dropdown s'aligne sur la section affectes. */
.affectation-carte-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width: 30rem;
}
.affectation-carte-field span {
  font-size: 1.2rem;
  font-weight: 600;
  color: #595959;
}
.affectation-carte-field select {
  width: 100%;
  padding: 0.7rem 0.9rem;
  border: 1px solid #d1d5db;
  border-radius: 0.6rem;
  font-size: 1.3rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  cursor: pointer;
}
.affectation-carte-field select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}
/* Champ filtre departement : largeur auto (ne suit pas le panneau, contrairement au lot). */
.affectation-carte-field--filtre {
  width: auto;
}
.affectation-carte-field--filtre select {
  width: 24rem;
}

/* ── Plateau : carte (tuile) a gauche, panneau (tuile) a droite ; empile en etroit. ── */
.affectation-carte-board {
  display: grid;
  grid-template-columns: 30rem minmax(0, 1fr);
  gap: 2.5rem;
  align-items: stretch;
}
@media screen and (max-width: 980px) {
  .affectation-carte-board {
    grid-template-columns: 1fr;
  }
}
/* Cellule de visualisation (droite) : carte OU liste. Sa hauteur = celle du PANNEAU de gauche
   (qui pilote la rangee). Le contenu est en absolu -> il n'allonge pas la rangee et remplit la
   cellule etiree (scroll interne si plus grand que le panneau). */
.affectation-carte-visu {
  min-width: 0;
  position: relative;
  /* Plancher : la box reste suffisamment haute meme si le panneau gauche a peu d'infos.
     Au-dela, elle suit la hauteur du panneau (rangee etiree). */
  min-height: 60rem;
}
.affectation-carte-visu > * {
  position: absolute;
  inset: 0;
}
/* Tuile carte : fond clair, carte centree et bornee. */
.affectation-carte-mapcard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 1.8rem;
  background: #fafbfc;
  border: 1px solid #eef0f2;
  border-radius: 1.2rem;
}
.affectation-carte-mapcard .carte-affectation {
  width: 100%;
  max-width: 460px;
}

/* ── Panneau lateral : action d'affectation + roster (affectes / non affectes). ── */
.affectation-carte-panel {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  padding: 1.5rem;
  background: #ffffff;
  border: 1px solid #eef0f2;
  border-radius: 1.2rem;
}

/* Chips des departements selectionnes + consigne, rendus DANS le Banner de selection (variant info). */
.affectation-panel-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.affectation-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.3rem 0.3rem 0.7rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  font-size: 1.1rem;
  color: #374151;
}
.affectation-chip-x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border: none;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 1.3rem;
  line-height: 1;
  cursor: pointer;
}
.affectation-chip-x:hover {
  background: #fee2e2;
  color: #dc2626;
}
/* Consigne sous les chips (dans le Banner) : bloc, ton neutre herite du Banner info. */
.affectation-panel-hint {
  display: block;
  margin-top: 0.6rem;
  font-size: 1.15rem;
}

/* Incitation (warning) + note "tout affecte" (success) : Banner sans marge (le gap gere). */
.affectation-incite-banner {
  margin: 0;
}
/* Bouton d'action de CE warning uniquement : texte plus petit (sinon il deborde dans le panneau). */
.button.affectation-incite-action {
  font-size: 1.2rem;
}

/* Roster : affectes (couleur + nb dep.) puis non affectes (pastille creuse). */
.affectation-panel-roster {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  max-height: 34rem;
  overflow-y: auto;
}
.affectation-roster-titre {
  margin-top: 0.6rem;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #595959;
}
.affectation-roster-vide {
  padding: 0.3rem 0.6rem;
  font-size: 1.1rem;
  color: #9ca3af;
}
.affectation-roster-row {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  padding: 0.5rem 0.6rem;
  border: none;
  background: none;
  border-radius: 0.5rem;
  text-align: left;
  font-size: 1.2rem;
  color: #374151;
  cursor: default;
}
.affectation-roster-row.is-actionnable {
  cursor: pointer;
}
.affectation-roster-row.is-actionnable:hover {
  background: #f3f4f6;
}
.affectation-roster-row:disabled {
  opacity: 0.6;
}
.affectation-roster-pastille {
  flex-shrink: 0;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.affectation-roster-pastille.is-vide {
  background: #ffffff;
  border-style: dashed;
  border-color: #cbd5e1;
}
.affectation-roster-nom {
  flex: 1 1;
  min-width: 0;
}
.affectation-roster-count {
  font-size: 1rem;
  font-weight: 600;
  color: #6b7280;
}

/* Etats neutres (rappel) sous le roster. */
.affectation-panel-etats {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-top: 0.9rem;
  border-top: 1px solid #e5e7eb;
}
.affectation-legende-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  color: #374151;
}
.affectation-legende-pastille {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.affectation-legende-pastille--libre {
  background: #e5e7eb;
  border-color: #cbd5e1;
}
.affectation-legende-pastille--hors {
  background: #6b7280;
  border-color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/composants/AffectationCarte/AffectationCarte.css"],"names":[],"mappings":"AAAA,kGAAkG;AAClG;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;uFACuF;AACvF;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA,4FAA4F;AAC5F;EACE,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mGAAmG;AACnG,oGAAoG;AACpG;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,4FAA4F;AAC5F;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA,yFAAyF;AACzF;EACE,aAAa;EACb,2CAA2C;EAC3C,WAAW;EACX,oBAAoB;AACtB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;;kEAEkE;AAClE;EACE,YAAY;EACZ,kBAAkB;EAClB;gEAC8D;EAC9D,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,qFAAqF;AACrF;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,uGAAuG;AACvG;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,uFAAuF;AACvF;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,4FAA4F;AAC5F;EACE,SAAS;AACX;AACA,oGAAoG;AACpG;EACE,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":["/* Section \"Affectation des membres sur les lots\" en vue carte. Palette fermee du design system. */\n.affectation-carte {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.affectation-carte-info {\n  color: #6b7280;\n  font-size: 1.3rem;\n  padding: 1rem 0;\n}\n\n/* ── Barre d'outils : dropdowns lot/departement a gauche, toggle Carte/Liste serre a droite.\n   Gap entre filtres = gap du board (panneau <-> carte), pour l'alignement visuel. ── */\n.affectation-carte-toolbar {\n  display: flex;\n  align-items: flex-end;\n  gap: 2.5rem;\n}\n.affectation-carte-toolbar .view-switch {\n  margin-left: auto;\n  align-self: flex-end;\n}\n/* Consigne : Banner info en tete de section (la marge est geree par le gap du conteneur). */\n.affectation-carte-consigne-banner {\n  margin: 0;\n}\n.affectation-carte-erreur {\n  padding: 0.9rem 1.2rem;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 0.6rem;\n  color: #b91c1c;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n/* Bascule Carte / Liste : composant partage ViewSwitch (style repris du selecteur de perimetre). */\n/* Largeur calee sur le panneau de gauche (30rem) -> le dropdown s'aligne sur la section affectes. */\n.affectation-carte-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  width: 30rem;\n}\n.affectation-carte-field span {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #595959;\n}\n.affectation-carte-field select {\n  width: 100%;\n  padding: 0.7rem 0.9rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.6rem;\n  font-size: 1.3rem;\n  font-family: inherit;\n  color: #374151;\n  background: #ffffff;\n  cursor: pointer;\n}\n.affectation-carte-field select:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n/* Champ filtre departement : largeur auto (ne suit pas le panneau, contrairement au lot). */\n.affectation-carte-field--filtre {\n  width: auto;\n}\n.affectation-carte-field--filtre select {\n  width: 24rem;\n}\n\n/* ── Plateau : carte (tuile) a gauche, panneau (tuile) a droite ; empile en etroit. ── */\n.affectation-carte-board {\n  display: grid;\n  grid-template-columns: 30rem minmax(0, 1fr);\n  gap: 2.5rem;\n  align-items: stretch;\n}\n@media screen and (max-width: 980px) {\n  .affectation-carte-board {\n    grid-template-columns: 1fr;\n  }\n}\n/* Cellule de visualisation (droite) : carte OU liste. Sa hauteur = celle du PANNEAU de gauche\n   (qui pilote la rangee). Le contenu est en absolu -> il n'allonge pas la rangee et remplit la\n   cellule etiree (scroll interne si plus grand que le panneau). */\n.affectation-carte-visu {\n  min-width: 0;\n  position: relative;\n  /* Plancher : la box reste suffisamment haute meme si le panneau gauche a peu d'infos.\n     Au-dela, elle suit la hauteur du panneau (rangee etiree). */\n  min-height: 60rem;\n}\n.affectation-carte-visu > * {\n  position: absolute;\n  inset: 0;\n}\n/* Tuile carte : fond clair, carte centree et bornee. */\n.affectation-carte-mapcard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  padding: 1.8rem;\n  background: #fafbfc;\n  border: 1px solid #eef0f2;\n  border-radius: 1.2rem;\n}\n.affectation-carte-mapcard .carte-affectation {\n  width: 100%;\n  max-width: 460px;\n}\n\n/* ── Panneau lateral : action d'affectation + roster (affectes / non affectes). ── */\n.affectation-carte-panel {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1.4rem;\n  padding: 1.5rem;\n  background: #ffffff;\n  border: 1px solid #eef0f2;\n  border-radius: 1.2rem;\n}\n\n/* Chips des departements selectionnes + consigne, rendus DANS le Banner de selection (variant info). */\n.affectation-panel-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.affectation-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.3rem 0.3rem 0.3rem 0.7rem;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 999px;\n  font-size: 1.1rem;\n  color: #374151;\n}\n.affectation-chip-x {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.6rem;\n  height: 1.6rem;\n  border: none;\n  border-radius: 50%;\n  background: #f3f4f6;\n  color: #6b7280;\n  font-size: 1.3rem;\n  line-height: 1;\n  cursor: pointer;\n}\n.affectation-chip-x:hover {\n  background: #fee2e2;\n  color: #dc2626;\n}\n/* Consigne sous les chips (dans le Banner) : bloc, ton neutre herite du Banner info. */\n.affectation-panel-hint {\n  display: block;\n  margin-top: 0.6rem;\n  font-size: 1.15rem;\n}\n\n/* Incitation (warning) + note \"tout affecte\" (success) : Banner sans marge (le gap gere). */\n.affectation-incite-banner {\n  margin: 0;\n}\n/* Bouton d'action de CE warning uniquement : texte plus petit (sinon il deborde dans le panneau). */\n.button.affectation-incite-action {\n  font-size: 1.2rem;\n}\n\n/* Roster : affectes (couleur + nb dep.) puis non affectes (pastille creuse). */\n.affectation-panel-roster {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  max-height: 34rem;\n  overflow-y: auto;\n}\n.affectation-roster-titre {\n  margin-top: 0.6rem;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #595959;\n}\n.affectation-roster-vide {\n  padding: 0.3rem 0.6rem;\n  font-size: 1.1rem;\n  color: #9ca3af;\n}\n.affectation-roster-row {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  width: 100%;\n  padding: 0.5rem 0.6rem;\n  border: none;\n  background: none;\n  border-radius: 0.5rem;\n  text-align: left;\n  font-size: 1.2rem;\n  color: #374151;\n  cursor: default;\n}\n.affectation-roster-row.is-actionnable {\n  cursor: pointer;\n}\n.affectation-roster-row.is-actionnable:hover {\n  background: #f3f4f6;\n}\n.affectation-roster-row:disabled {\n  opacity: 0.6;\n}\n.affectation-roster-pastille {\n  flex-shrink: 0;\n  width: 1.4rem;\n  height: 1.4rem;\n  border-radius: 0.3rem;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n.affectation-roster-pastille.is-vide {\n  background: #ffffff;\n  border-style: dashed;\n  border-color: #cbd5e1;\n}\n.affectation-roster-nom {\n  flex: 1;\n  min-width: 0;\n}\n.affectation-roster-count {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n/* Etats neutres (rappel) sous le roster. */\n.affectation-panel-etats {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding-top: 0.9rem;\n  border-top: 1px solid #e5e7eb;\n}\n.affectation-legende-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  color: #374151;\n}\n.affectation-legende-pastille {\n  width: 1.4rem;\n  height: 1.4rem;\n  border-radius: 0.3rem;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n.affectation-legende-pastille--libre {\n  background: #e5e7eb;\n  border-color: #cbd5e1;\n}\n.affectation-legende-pastille--hors {\n  background: #6b7280;\n  border-color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
